export interface IPNSAccountVerification {
  username: string;
  confirmPassword: string;
  displayPhoneNumber: string;
  password: string;
  phoneNumber: string;
  token: string;
}
